import { ApolloClient, InMemoryCache } from '@apollo/client';

const createInRutaClient = () => {
  const uri = 'https://88u3zfcw11.execute-api.us-east-1.amazonaws.com/dev/graphql';
  const client = new ApolloClient({
    uri,
    cache: new InMemoryCache(),
  });
  return client;
};

export default createInRutaClient;
